import { StargateAPI } from '@atlassian/mpac-services-client';
export async function getAvailableSites(marketplaceProduct) {
  const stargate = new StargateAPI('/gateway/api');
  return stargate.marketplace.availableSites([marketplaceProduct]);
}